import { useModal } from '@/composables/modal'
import { useCore } from '../core/index.js'
import { useAnalytics } from '../analytics/index.js'
import fakeDoorImage from '@/assets/images/fake-door.png'

type FakeDoorImage = {
  url: string;
  height: string;
}

type SendAnalyticsEvent = (eventAction: unknown) => void

type OpenFakeDoorOptions = {
  onClose?: () => void;
  onCancel?: () => void;
  title?: string;
  text?: string;
  sendAnalyticsEvent?: SendAnalyticsEvent;
  img?: FakeDoorImage;
  modalOptions?: Record<string, unknown>;
}

type UseModal = {
  open: (options: Record<string, unknown>) => Promise<unknown>;
  close: () => void;
}

type UseAnalytics = {
  EVENT_ACTIONS: {
    VIEW_OPENED: unknown;
    PROCEED_CLICKED: unknown;
  };
}

type UseFakeDoorReturn = {
  open: (options?: OpenFakeDoorOptions) => Promise<unknown>;
  close: () => void;
}

const getModal = (): UseModal => useModal() as UseModal

const open = async ({
  onClose,
  onCancel,
  title,
  text,
  sendAnalyticsEvent = () => {},
  img = {
    url: fakeDoorImage,
    height: '185px',
  },
  modalOptions = {},
}: OpenFakeDoorOptions = {}): Promise<unknown> => {
  const modal = getModal()
  const { t } = useCore() as { t: (key: string) => string }
  const analytics = useAnalytics() as UseAnalytics

  sendAnalyticsEvent(analytics.EVENT_ACTIONS.VIEW_OPENED)

  return modal.open({
    width: '448px',
    class: 'b-items-stretch md:b-items-start',
    content: {
      $image: img,
      $title: title || t('fake-door.title'),
      $text: text || t('fake-door.description'),
    },
    buttons: [
      {
        $text: t('fake-door.ok'),
        size: 'lg',
        theme: 'primary',
        '@click': () => {
          sendAnalyticsEvent(analytics.EVENT_ACTIONS.PROCEED_CLICKED)
          getModal().close()
        },
      },
    ],
    onClose: onClose || (() => {}),
    onCancel: onCancel || (() => {}),
    ...modalOptions,
  })
}

export function useFakeDoor (): UseFakeDoorReturn {
  return {
    open,
    close: () => getModal().close(),
  }
}
